// extracted by mini-css-extract-plugin
export default {"studio-modal-button":"pSj6pQ","studioModalButton":"pSj6pQ"};